import ar from './ar.json';
import de from './de.json';
import en from './en.json';
import es from './es.json';
import fa from './fa.json';
import fr from './fr.json';
import it from './it.json';
import ja from './ja.json';
import pt from './pt.json';
import ru from './ru.json';
import tr from './tr.json';

const messages = {
  ar,
  de,
  en,
  es,
  fa,
  fr,
  it,
  ja,
  pt,
  ru,
  tr,
};

export default messages;
